module.exports = __webpack_public_path__ + "static/baileykevinpoohwithfans-77746bfbf4b11b226d8b5caac44ae3ef.jpg";